import { m3IntermediateR, m3IntermediateD } from "../../../../data/clueData";

export const IntermediateStageClearData = {
  missionNumber: "3",
  missionTitle: "Intermediate",
  missionDebrief: `"The receipt gives a name—‘Foxy Parts.’ ByteFox is leaving hints, but their motives remain unclear. Try Advanced or move to the next mission."`,
  description:
    "Complete all missions to this level and receive a special invite at the project debriefing.",
  nextLevel: "/digitalBreadcrumbs",
  selectedLevel: "advanced",
};

export const IntermediateStageFailData = {
  missionNumber: "3",
  missionTitle: "Intermediate",
  levelName: "Intermediate",
  description: "Every challenge is an opportunity to learn and grow.",
  nextLevel: "/rookie",
};

export const clueData = {
  message: null,
  clueItems: [
    { icon: m3IntermediateR, description: null },
    { icon: m3IntermediateD, description: null },
  ],
};
